import $http from "../../axios";
import { Notification } from "element-ui";

export async function fetchProductParentList({ commit, rootState }, params) {
    const product = rootState.products.selectedProduct;
    const product_id = product ? product.id : null;

    await $http
        .get(`/api/product-parent`, {
            params: {
                ...params,
                product_id
            }
        })
        .then(response => {
            commit("setProductParentList", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function fetchProductParent({ commit }, id) {
    await $http
        .get(`/api/product-parent/${id}`)
        .then(response => {
            commit("setProductParentItem", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function fetchProductParentPublic({ commit }, id) {
    await $http
        .get(`/api/find-product-parent-public`, {
            params: {
                id
            }
        })
        .then(response => {
            commit("setProductParentItem", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function createProductParent({ dispatch }, payload) {
    await $http
        .post(`/api/product-parent`, payload)
        .then(() => {
            Notification.success({
                title: "Success!",
                message: "Referencia padre creada con exito",
                duration: 2000,
                customClass: "notification-box"
            });

            dispatch("fetchProductParentList");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function updateProductParent({ dispatch }, { id, payload }) {
    await $http
        .put(`/api/product-parent/${id}`, payload)
        .then(() => {
            Notification.success({
                title: "Success!",
                message: "Referencia padre actualizada con exito",
                duration: 2000,
                customClass: "notification-box"
            });

            dispatch("fetchProductParentList");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function deleteProductParent({ dispatch }, id) {
    await $http
        .delete(`/api/product-parent/${id}`)
        .then(() => {
            Notification.success({
                title: "Success!",
                message: "Referencia padre eliminado con exito",
                duration: 2000,
                customClass: "notification-box"
            });

            dispatch("fetchProductParentList");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function fetchProductParentByPage({ commit, state }) {
    await $http
        .get("/api/product-parent-by-page", {
            params: state.params
        })
        .then(response => {
            commit("setProductParentByPage", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

let saveTimeout = null;
let saveDataSheetController = null;

export async function saveProductParentDataSheets(
    { commit },
    { product_parent_id, data_sheets }
) {
    // 🔹 Cancelar request anterior
    if (saveDataSheetController) {
        saveDataSheetController.abort();
    }

    // 🔹 Limpiar timeout anterior
    if (saveTimeout) {
        clearTimeout(saveTimeout);
    }

    // 🔹 Debounce de 600ms
    return new Promise(function(resolve, reject) {
        saveTimeout = setTimeout(async function() {
            saveDataSheetController = new AbortController();

            try {
                const response = await $http.post(
                    "/api/product-parent/data-sheets",
                    {
                        product_parent_id: product_parent_id,
                        data_sheets: data_sheets
                    },
                    {
                        signal: saveDataSheetController.signal
                    }
                );

                resolve(response.data);
            } catch (error) {
                if (
                    error.name === "CanceledError" ||
                    error.name === "AbortError"
                ) {
                    return;
                }

                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    duration: 2000,
                    customClass: "notification-box"
                });

                reject(error);
            }
        }, 600);
    });
}

export async function saveProductParentColorImages({ commit }, payload) {
    const product_parent_id = payload.product_parent_id;
    const images = payload.images || [];

    const formData = new FormData();

    formData.append("product_parent_id", product_parent_id);

    const meta = images.map(function(item) {
        return {
            id: item.id || null,
            uid: item.uid,
            color_id: item.color_id,
            order: item.order,
            persisted: !!item.persisted
        };
    });

    formData.append("images_meta", JSON.stringify(meta));

    images.forEach(function(item) {
        if (item.image && item.image instanceof File) {
            formData.append("files[" + item.uid + "]", item.image);
        }
    });

    try {
        const response = await $http.post(
            "/api/product-parent/save-color-images",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function saveQuotationImages({ commit }, payload) {
    var product_parent_id = payload.product_parent_id;
    var headers = payload.headers || [];
    var gallery = payload.gallery;
    var video = payload.video;

    var formData = new FormData();

    formData.append("product_parent_id", product_parent_id);

    // HEADERS
    var headersMeta = headers.map(function(item) {
        return {
            id: item.id || null,
            uid: item.uid || null,
            order: item.order || 0,
            image_path: item.image_path || "",
            persisted: item.persisted ? 1 : 0
        };
    });

    formData.append("headers_meta", JSON.stringify(headersMeta));

    headers.forEach(function(item) {
        if (item.file && item.file instanceof File) {
            formData.append("headers_files[" + item.uid + "]", item.file);
        }
    });

    // VIDEO
    if (video) {
        formData.append(
            "video_meta",
            JSON.stringify({
                id: video.id || null,
                image_path: video.image_path || "",
                persisted: video.persisted ? 1 : 0
            })
        );

        if (video.file && video.file instanceof File) {
            formData.append("video_file", video.file);
        }
    } else {
        formData.append("video_meta", "");
    }

    // GALLERY
    gallery = gallery || [];

    var galleryMeta = gallery.map(function(item) {
        return {
            id: item.id || null,
            uid: item.uid || null,
            order: item.order || 0,
            image_path: item.image_path || "",
            persisted: item.persisted ? 1 : 0
        };
    });

    formData.append("gallery_meta", JSON.stringify(galleryMeta));

    gallery.forEach(function(item) {
        if (item.file && item.file instanceof File) {
            formData.append("gallery_files[" + item.uid + "]", item.file);
        }
    });

    try {
        var response = await $http.post(
            "/api/product-parent/quotation-images",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}

// Guardar o actualizar accesorio
export async function saveProductParentAccessory(
    {},
    { product_parent_id, product_id, order }
) {
    try {
        const response = await $http.post("/api/product-parent/accessories", {
            product_parent_id: product_parent_id,
            product_id: product_id,
            order: order
        });

        return response.data;
    } catch (error) {
        Notification.error({
            title: "Error!",
            message:
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message,
            duration: 2000,
            customClass: "notification-box"
        });

        throw error;
    }
}

// Eliminar accesorio
export async function deleteProductParentAccessory(
    {},
    { product_parent_id, product_id }
) {
    try {
        const response = await $http.delete("/api/product-parent/accessories", {
            data: {
                product_parent_id: product_parent_id,
                product_id: product_id
            }
        });

        return response.data;
    } catch (error) {
        Notification.error({
            title: "Error!",
            message:
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message,
            duration: 2000,
            customClass: "notification-box"
        });

        throw error;
    }
}

export async function fetchProductsForSelect({}, { text }) {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await $http.get("/api/lista-productos-select", {
                params: {
                    filter: text,
                    attachments: true,
                    prices: true
                }
            });

            resolve(response.data);
        } catch (error) {
            Notification.error({
                title: "Error!",
                message:
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message,
                duration: 2000
            });

            reject(error);
        }
    });
}

export async function syncProductParentAccessories(
    {},
    { product_parent_id, accessories }
) {
    try {
        const response = await $http.post(
            "/api/product-parent/accessories/sync",
            {
                product_parent_id: product_parent_id,
                accessories: accessories
            }
        );

        return response.data;
    } catch (error) {
        Notification.error({
            title: "Error!",
            message:
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message,
            duration: 2000
        });

        throw error;
    }
}

export async function uploadProductImage({}, { product_id, file }) {
    const formData = new FormData();

    formData.append("file", file);

    try {
        const response = await $http.post(
            `/api/imagenes-producto/${product_id}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/modules/product-parent/actions.js